import { SVGProps } from 'react';

export const KeywordsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='22'
    height='22'
    viewBox='0 0 26 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M15.926 4.31055H20.1201C21.1365 4.31055 21.9605 5.07441 21.9605 6.01674V18.9837C21.9605 19.9259 21.1365 20.6899 20.1201 20.6899H15.926'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M9.12066 4.31055H4.92661C3.9102 4.31055 3.08618 5.07441 3.08618 6.01674V18.9837C3.08618 19.9259 3.91014 20.6899 4.92661 20.6899H9.12066'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path d='M13.9843 16.2124H10.1128L9.59147 17.8505H6.98584L10.53 7.42676H13.5678L17.112 17.8505H14.5057L13.9843 16.2124ZM13.2695 13.979L12.0486 10.1518L10.8276 13.979H13.2695Z' />
  </svg>
);
